import ChatView from "@jane/lib/src/chat";
import React, {FC} from "react"
import {config} from "../../config";
import {useEmployeesData} from "../../resources/EmployeeContext";
import {useTeamData} from "../../resources/TeamContext";
import {useApiCall, useApiEndpoint} from "../../../../lib/src/api";
import {usePermissions} from "../../resources/PermissionsHook";


const ChatPage: FC = () => {
  const {teams} = useTeamData()
  const {employees} = useEmployeesData()
  const {teams: teamsApi} = useApiCall(config)
  const {canListTeams} = usePermissions()
  const { resource: teamResource, isLoading: loadingTeam } = useApiEndpoint(() => teamsApi.myTeam(), canListTeams)
  const { resource: secondaryTeams, isLoading: loadingSecondaryTeams } = useApiEndpoint(() => teamsApi.myTeams(), canListTeams)
  return <ChatView
    config={config}
    rocketChatHostname={config.rocketChatHostname}
    teams={teams ?? []}
    primaryTeam={teamResource ?? null}
    secondaryTeams={secondaryTeams ?? []}
    employees={employees ?? []}
  />
}
export default ChatPage

